module.exports = __webpack_public_path__ + "static/img/menu_icon3.0dc0affa.png";